/**
 * Loads and caches the Scoreboard UI content.
 * The Scoreboard page awaits this on first load; child components
 * call it without await and receive the already-cached result instantly.
 */
export function useScoreboardUI() {
  return useAsyncData('scoreboard-ui', () =>
    queryCollection('scoreboardUI').first(),
  )
}
